<div class="alert d-block {{ object?.notificationType }} m-0">{{ object?.message | translate }}</div>
